import axios from 'axios';



const API_BASE_URL = process.env.REACT_APP_API_URL 





console.log('API Base URL:', API_BASE_URL);
console.log('Production mode:', process.env.NODE_ENV === 'production');
console.log('Environment:', process.env.NODE_ENV);
console.log('All env vars:', Object.keys(process.env).filter(key => key.startsWith('REACT_APP')));

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to log all API calls
apiClient.interceptors.request.use(
  (config) => {
    console.log('🚀 API Request:', {
      method: config.method?.toUpperCase(),
      url: `${config.baseURL}${config.url}`,
      data: config.data
    });
    return config;
  },
  (error) => {
    console.error('❌ Request Error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor to log responses
apiClient.interceptors.response.use(
  (response) => {
    console.log('✅ API Response:', {
      status: response.status,
      url: response.config.url,
      data: response.data
    });
    return response;
  },
  (error) => {
    console.error('❌ API Error:', {
      status: error.response?.status,
      url: error.config?.url,
      message: error.message
    });
    return Promise.reject(error);
  }
);

// API methods
export const chatAPI = {
  // Regular chat
  sendMessage: (data) => apiClient.post('/api/chat', data),
  
  // Streaming chat
  sendStreamMessage: (data) => {
    const url = `${API_BASE_URL}/api/chat_stream`;
    console.log('🚀 Fetch Request:', { method: 'POST', url, data });
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    }).then(response => {
      console.log('✅ Fetch Response:', { status: response.status, url });
      return response;
    }).catch(error => {
      console.error('❌ Fetch Error:', { url, error: error.message });
      throw error;
    });
  },
  
  // Chat with image
  sendMessageWithImage: (formData) => {
    return apiClient.post('/api/chat-with-image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  
  // Get agent image
  getAgentImage: (category, filename) => {
    return `${API_BASE_URL}/api/agent-images/${category}/${filename}`;
  },
  
  // Chatbot status
  getStatus: () => apiClient.get('/api/chatbot-status'),
  
  // Get available countries
  getCountries: () => {
    console.log('Making API call to /api/countries');
    return apiClient.get('/api/countries');
  },
  
  // Arabic TTS
  getArabicTTS: (text) => apiClient.post('/api/arabic-tts', { text }),
  
  // English TTS
  getEnglishTTS: (text) => apiClient.post('/api/english-tts', { text }),
  
  // Whisper Speech-to-Text
  speechToText: (audioBlob) => {
    const formData = new FormData();
    formData.append('file', audioBlob);
    return apiClient.post('/api/speech-to-text', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  
  // Context methods
  sendContext: (contextData) => apiClient.post('/api/context', contextData),
  getContext: (sessionId) => apiClient.get(`/api/context?sessionId=${sessionId}`),
  
  // Admin Dashboard APIs
  getDashboardStatus: () => apiClient.get('/api/dashboard/status'),
  toggleMaintenance: (data) => apiClient.post('/api/dashboard/maintenance', data),
  toggleAgent: (data) => apiClient.post('/api/dashboard/agent-control', data),
  resetStats: () => apiClient.post('/api/dashboard/reset-stats'),
  
  // RAG Management APIs
  directIngest: (data) => apiClient.post('/api/rag/direct-ingest', data),
  bulkIngest: (data) => apiClient.post('/api/rag/bulk-ingest-new', data),
  scrapeAndIngest: (data) => apiClient.post('/api/rag/scrape-and-ingest', data),
  getRagDatabases: () => apiClient.get('/api/rag/databases'),
  deleteFromDatabase: (dbName, urlEncoded) => apiClient.delete(`/api/rag/database/${dbName}/delete/${urlEncoded}`),
  getDatabaseStats: (dbName) => apiClient.get(`/api/rag/database/${dbName}/stats`),
  
  // Prompt Management APIs
  getAllPrompts: () => apiClient.get('/api/prompts/all'),
  saveAgentPrompt: (data) => apiClient.post('/api/prompts/agent', data),
  saveCommonPrompt: (data) => apiClient.post('/api/prompts/common', data),
  saveTone: (data) => apiClient.post('/api/prompts/tone', data),
  
  // Guardrails APIs
  getGuardrailsStatus: () => apiClient.get('/api/guardrails/status'),
  updateGuardrailsConfig: (data) => apiClient.post('/api/guardrails/config', data),
  getAuditLogs: () => apiClient.get('/api/guardrails/audit-log'),
  testGuardrails: (data) => apiClient.post('/api/guardrails/test', data),
  
  // Conversation Management APIs
  getConversations: (params) => {
    if (params && params.sessionId) {
      // Get messages for specific session
      return apiClient.get(`/api/conversation-messages/${params.sessionId}`);
    } else {
      // Get all sessions
      return apiClient.get('/api/conversation-sessions');
    }
  },
  deleteConversation: (id) => {
    if (id === 'all') {
      return apiClient.delete('/api/conversations-delete-all');
    } else {
      return apiClient.delete(`/api/conversation-delete/${id}`);
    }
  },
  exportConversations: (params) => apiClient.get('/api/conversations-export', { params }),
  
  // Feedback APIs
  submitFeedback: (data) => apiClient.post('/api/feedback', data),
  getFeedback: (params) => apiClient.get('/api/feedback', { params }),
  
  // Flight Booking APIs
  searchFlights: (data) => apiClient.post('/api/flight-search', data),
  selectFlight: (data) => apiClient.post('/api/flight-select', data),
  getSeatMap: (flightId) => apiClient.get(`/api/seat-map/${flightId}`),
  selectSeat: (data) => apiClient.post('/api/seat-select', data),
  addPassenger: (data) => apiClient.post('/api/passenger-add', data),
  getFareBreakdown: (bookingId) => apiClient.get(`/api/fare-breakdown/${bookingId}`),
  proceedCheckout: (data) => apiClient.post('/api/checkout', data),
  confirmBooking: (data) => apiClient.post('/api/booking-confirm', data)
};

export default apiClient;
